import * as wConst from "../consts/website-consts.js";
export const InitState = {
  Loaded: false,
  AdUserInfo: {
    Result: {
      Code: 200,
      UserId: 0,
      Message: "Not logged in."
    }
  },
  AllCountries: {
    Result: {
      Code: 500,
      Message: "There is no results yet"
    }
  },
  AdCountries: {
    Result: {
      Code: 500,
      Message: "There is no results yet"
    }
  },
  AdSizes: {
    Loaded: false,
    Result: {
      Code: 500,
      Message: "There is no results yet"
    }
  },
  AdPackages: {
    Loaded: false,
    Result: {
      Code: 500,
      Message: "There is no results yet"
    }
  },
  AdUserTypes: {
    Loaded: false,
    Result: {
      Code: 500,
      Message: "There is no results yet"
    }
  },
  AdUrl: {
    Loaded: false,
    Loading: false,
    Result: {
      Code: 500,
      Message: "There is no results yet"
    }
  },
  AdUpload: {
    Loaded: false,
    Result: {
      Code: 500,
      Message: "There is no results yet"
    }
  },
  Order: {
    Loaded: false,
    Result: {
      Code: 500,
      Message: ""
    }
  },
  SSRAds: {},
};

export const adReducer = (state = InitState, action) => {
  switch (action.type) {
    case wConst.FETCH_ADS_PENDING: {
      state = {...state, Loaded: false};
      break;
    }
    case wConst.FETCH_ADS_REJECTED: {
        state = {...state, Loaded: false,
          AdCountries: action.payload.Countries,
          AdPackages: action.payload.Packages,
          AllCountries: action.payload.AllCountries,
          AdSizes: action.payload.Sizes,
          AdUserInfo: action.payload.UserInfo,
          AdUserTypes: action.payload.UserTypes
      };
      break;
    }
    case wConst.FETCH_ADS_FULLFILLED: {
      state = {...state, Loaded: true,
        AdCountries: action.payload.Countries,
        AdPackages: action.payload.Packages,
        AllCountries: action.payload.AllCountries,
        AdSizes: action.payload.Sizes,
        AdUserInfo: action.payload.UserInfo,
        AdUserTypes: action.payload.UserTypes,
      };
      state.AdPackages.Loaded = true;
      state.AdSizes.Loaded = true;
      break;
    }
    case wConst.FETCH_ADSURL_PENDING: {
      state = {...state,  AdUrl: {...state.AdUrl, Loaded: false, Loading: true}};
      break;
    }
    case wConst.FETCH_ADSURL_REJECTED: {
      state = {...state, AdUrl: {Loading: false, Loaded: true, Result: action.payload}};
      break;
    }
    case wConst.FETCH_ADSURL_FULLFILLED: {
      state = {...state, AdUrl: {Loading: false, Loaded: true, Result: action.payload}};
      break;
    }
    case wConst.FETCH_ADSPACKS_PENDING: {
      state = {...state,  AdPackages: {Loaded: false}};
      break;
    }
    case wConst.FETCH_ADSPACKS_REJECTED: {
      state = {...state,  AdPackages: {Loaded: false, ...action.payload}};
      break;
    }
    case wConst.FETCH_ADSPACKS_FULLFILLED: {
      state = {...state,  AdPackages: {Loaded: true, ...action.payload}};
      break;
    }
    case wConst.FETCH_ADSSIZES_PENDING: {
      state = {...state,  AdSizes: {Loaded: false}};
      break;
    }
    case wConst.FETCH_ADSSIZES_REJECTED: {
      state = {...state,  AdSizes: {Loaded: false, ...action.payload}};
      break;
    }
    case wConst.FETCH_ADSSIZES_FULLFILLED: {
      state = {...state,  AdSizes: {Loaded: true, ...action.payload}};
      break;
    }
    case wConst.FETCH_ADUPLOAD_PENDING: {
      state = {...state,  AdUpload: {Loaded: false}};
      break;
    }
    case wConst.FETCH_ADUPLOAD_REJECTED: {
      state = {...state,  AdUpload: {Loaded: false, ...action.payload}};
      break;
    }
    case wConst.FETCH_ADUPLOAD_FULLFILLED: {
      state = {...state,  AdUpload: {Loaded: true, ...action.payload}};
      break;
    }
    case wConst.DEF_CHECKORDER_PENDING: {
      state = {...state,  Order: {...state.Order, Loaded: false}};
      break;
    }
    case wConst.DEF_CHECKORDER_FAILED: {
      state = {...state,  Order: {Loaded: false, ...action.payload}};
      break;
    }
    case wConst.DEF_CHECKORDER_SUCCESS: {
      state = {...state,  Order: {Loaded: true, ...action.payload}};
      break;
    }
    case wConst.FETCH_SSRADS_PENDING: {
      let tObj = {Loaded: false, ApiResult: {Code: 500, Message: "Loading"}};
      state.SSRAds[action.payload] = tObj;
      break;
    }
    case wConst.FETCH_SSRADS_REJECTED: {
      let tObj = {Loaded: true, ApiResult: action.payload.Value};
      state.SSRAds[action.payload.Key] = tObj;
      break;
    }
    case wConst.FETCH_SSRADS_FULLFILLED: {
      let tObj = {Loaded: true, ApiResult: action.payload.Value};
      state.SSRAds[action.payload.Key] = tObj;
      break;
    }


  }
  return state;
};


